import { render, staticRenderFns } from "./CheckboxFild.vue?vue&type=template&id=64a1d290"
import script from "./CheckboxFild.vue?vue&type=script&lang=js"
export * from "./CheckboxFild.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports